import React from 'react';

import './index.less';

interface PropType {
  rightLabels: { text: string }[];
  preferedDispatchId: string;
  semiHosted: boolean;
  productIsMarketGoods: boolean;
  shippingToCountry: string;
  i18n: {
    [t: string]: string;
  };
}

export default function LocalStock(props: PropType) {
  let { rightLabels = [] } = props;
  if (rightLabels.length === 0) return null;

  return (
    <div className="local-stock">
      <div className="inner">
        <svg
          width="17"
          height="18"
          viewBox="0 0 17 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.3542 5.80963V8.58331H15.5V4.55363C15.5 4.31052 15.359 4.08946 15.1386 3.98693L8.26358 0.789256C8.09646 0.711524 7.90354 0.711524 7.73642 0.789256L0.861418 3.98693C0.64098 4.08946 0.5 4.31052 0.5 4.55363V13.4464C0.5 13.6895 0.64098 13.9105 0.861418 14.0131L7.73642 17.2107C7.90354 17.2885 8.09646 17.2885 8.26358 17.2107L8.57292 17.0669L8.57291 8.53022L14.3542 5.80963ZM2.0119 4.71553L8 1.93037L13.9881 4.71553L7.99999 7.53346L2.0119 4.71553ZM7.42708 15.8031L1.64583 13.1142V5.80964L7.42708 8.53022V15.8031Z"
            fill="#D04A0A"
          />
          <path
            d="M13.2083 13.5833C13.7836 13.5833 14.25 13.1169 14.25 12.5416C14.25 11.9663 13.7836 11.5 13.2083 11.5C12.633 11.5 12.1667 11.9663 12.1667 12.5416C12.1667 13.1169 12.633 13.5833 13.2083 13.5833Z"
            fill="#D04A0A"
          />
          <path
            d="M13.2083 16.9166C13.2083 16.9166 16.3333 14.4485 16.3333 12.4166C16.3333 10.7598 14.9342 9.41665 13.2083 9.41665C11.4824 9.41665 10.0833 10.7598 10.0833 12.4166C10.0833 14.4485 13.2083 16.9166 13.2083 16.9166ZM14.8481 13.4121C14.61 13.8324 14.2768 14.2633 13.9178 14.6635C13.6732 14.9362 13.4269 15.1834 13.2083 15.3907C12.9898 15.1834 12.7434 14.9362 12.4988 14.6635C12.1398 14.2633 11.8066 13.8324 11.5686 13.4121C11.3235 12.9795 11.2292 12.6456 11.2292 12.4166C11.2292 11.4363 12.0707 10.5625 13.2083 10.5625C14.3459 10.5625 15.1875 11.4363 15.1875 12.4166C15.1875 12.6456 15.0932 12.9795 14.8481 13.4121Z"
            fill="#D04A0A"
          />
        </svg>
        <span>{rightLabels[0]?.text}</span>
      </div>
    </div>
  );
}
